import CONFIG from '~/config'

export const setHideSMSOptInModalItem = () => localStorage.setItem(CONFIG.COOKIE_HIDE_SMS_OPT_IN_MODAL, true)
export const removeSMSOptInModalItem = () => localStorage.removeItem(CONFIG.COOKIE_HIDE_SMS_OPT_IN_MODAL)
export const getSMSOptInModalItem = () => !!localStorage.getItem(CONFIG.COOKIE_HIDE_SMS_OPT_IN_MODAL)
